import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { KYMW0500Component } from './kymw0500.component';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { GetRelatedDataService } from './api-services/get-related-data.service';
import { GetGoodsDataService } from './api-services/get-goods-data.service';
import { RegistRelatedDataService } from './api-services/regist-related-data.service';
/**
 * 紐付設定画面　モジュール設定クラス
 *
 * @export KYMW0500Module
 * @class KYMW0500Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW0500Component,
  ],
  providers: [
    GetRelatedDataService,
    GetGoodsDataService,
    RegistRelatedDataService,
  ],
})

export class KYMW0500Module { }
